import Text from "@commons/Typography/Text";
import Button from "@commons/Button";
import Heading from "@commons/Typography/Heading";
import type { GeoJsonFeature } from "@typings/components/map";
import type { RegisterGeoJsonProperties } from "@services/registers/getGeoJson/type";
import { REGISTER_TYPE_LABELS } from "@typings/entities/registers/enums";

interface RegisterPopupProps {
  feature: GeoJsonFeature<RegisterGeoJsonProperties>;
  onNavigate: (path: string) => void;
}

function RegisterPopup({ feature, onNavigate }: RegisterPopupProps) {
  if (!feature || !feature.properties) {
    return (
      <div className="p-3">
        <Text size="sm" className="text-red-500">
          Erro ao carregar dados
        </Text>
      </div>
    );
  }

  const register = feature.properties;
  const coordinates = feature.geometry.coordinates;

  const handleNavigate = () => {
    onNavigate(`/registers/${register.id}`);
  };

  return (
    <div className="flex flex-col gap-3 px-2 py-1 min-w-[220px]">
      <div className="flex items-center justify-between">
        <Heading size="sm">{REGISTER_TYPE_LABELS[register.type]}</Heading>
      </div>

      <div className="space-y-2">
        <Text size="sm" className="font-roboto">
          <span className="font-semibold">Coordenadas:</span>{" "}
          {coordinates[1].toFixed(6)}, {coordinates[0].toFixed(6)}
        </Text>

        <Text size="sm" className="font-roboto">
          <span className="font-semibold">Coletado por:</span>{" "}
          {register.reporterName || "N/A"}
        </Text>

        <Text size="sm" className="font-roboto">
          <span className="font-semibold">Espécie:</span>{" "}
          {register.speciesName || "N/A"}
        </Text>

        <Text size="sm" className="font-roboto">
          <span className="font-semibold">Anexos:</span>{" "}
          {register.attachmentsCount}
        </Text>
      </div>

      <Button
        size="auto"
        customVariant="secondary"
        className="mt-2"
        onClick={handleNavigate}
      >
        Mais Detalhes
      </Button>
    </div>
  );
}

export default RegisterPopup;
